import { render, staticRenderFns } from "./viewerBIMModuleModelTree.vue?vue&type=template&id=94f081c4&scoped=true"
import script from "./viewerBIMModuleModelTree.vue?vue&type=script&lang=js"
export * from "./viewerBIMModuleModelTree.vue?vue&type=script&lang=js"
import style0 from "./viewerBIMModuleModelTree.vue?vue&type=style&index=0&id=94f081c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f081c4",
  null
  
)

export default component.exports